import React, { Fragment, useEffect, useState } from 'react'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { PreviousStep } from './PreviousStep'
import { AsnReceiveFilters, AsnToReceive } from '../Interfaces'
import { useApi } from '../../../hooks/useApi'
import { AxiosResponse } from 'axios'
import { getAsnToReceiveById } from '../api'
import { useStyles } from '../styles'
import { utcToLocal } from '../../../utils/dateHelper'

interface AsnSummaryProps {
  controls: StepperControls
  asnNumber: string
  getAsnSummary: (filters: AsnReceiveFilters) => Promise<AxiosResponse<any>>
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const AsnSummary: React.FC<AsnSummaryProps> = ({
  controls,
  asnNumber,
  getAsnSummary,
  openSnackBar
}) => {
  const classes = useStyles()
  const { callApi } = useApi<AsnToReceive[]>()
  const [selectedASN, setSelectedASN] = useState<AsnToReceive>()
  const [loading, setLoading] = useState(true)

  const requestAsnToReceive = async () => {
    const filters: AsnReceiveFilters = { asnNumber: asnNumber }
    callApi(getAsnSummary(filters))
      .then((response: AsnToReceive[]) => {
        setSelectedASN(response[0])
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const requestAsnToReceiveById = async (asnId: number) => {
    callApi(getAsnToReceiveById(asnId || 0))
      .then((response: AsnToReceive) => {
        setSelectedASN(response)
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (controls.currentState) {
      requestAsnToReceiveById(controls.currentState as number)
    } else {
      requestAsnToReceive()
    }
  }, [controls.currentState])

  return (
    <Fragment>
      <PreviousStep controls={controls}></PreviousStep>
      {loading ? (
        <CircularProgress />
      ) : (
        <div>
          <Box
            component='div'
            display='flex'
            flexDirection='column'
            flexWrap='nowrap'
            alignItems='left'
            padding='10px'
          >
            <Typography
              variant='h5'
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                marginTop: '30px'
              }}
            >
              {`Bultos Totales: ${selectedASN?.lpnQty}`}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>ASN: </b> {selectedASN?.asnNumber}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Fecha de creación: </b>
              {utcToLocal(selectedASN?.asnCreatedDate!, 'dd-MM-yyyy')}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Proveedor: </b> {selectedASN?.supplierName}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Origen: </b> {selectedASN?.supplierOriginName}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Estado: </b> {selectedASN?.asnStateName}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Total SKU: </b> {selectedASN?.skuQty}
            </Typography>
            <Typography variant='h6' className={classes.details}>
              <b>Total Unidades: </b> {selectedASN?.unitsQty}
            </Typography>
          </Box>

          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            style={{
              marginTop: '20px',
              width: '95%',
              minWidth: '95%'
            }}
            onClick={() => {
              controls.goToNextStep(selectedASN?.asnId)
            }}
          >
            CONTROLAR LPNs
          </Button>
        </div>
      )}
    </Fragment>
  )
}
